const PARAGUAY_COUNTRY_CODE = '595' as const;
const PARAGUAY_PHONE_MIN_LENGTH = 8;
const PARAGUAY_PHONE_MAX_LENGTH = 10;

const sanitizePhoneDigits = (value: string | number | null | undefined): string => {
    return String(value || '')
        .replace(/^whatsapp:/i, '')
        .replace(/\D+/g, '');
};

export const normalizeParaguayPhone = (value: string | number | null | undefined): string | null => {
    let digits = sanitizePhoneDigits(value);

    if (!digits) {
        return null;
    }

    if (digits.startsWith('00')) {
        digits = digits.replace(/^00+/, '');
    }

    if (digits.startsWith(PARAGUAY_COUNTRY_CODE)) {
        digits = digits.slice(PARAGUAY_COUNTRY_CODE.length);
    }

    digits = digits.replace(/^0+/, '');

    if (digits.length < PARAGUAY_PHONE_MIN_LENGTH || digits.length > PARAGUAY_PHONE_MAX_LENGTH) {
        return null;
    }

    return `+${PARAGUAY_COUNTRY_CODE}${digits}`;
};

export const toWhatsappWebPhone = (value: string | number | null | undefined): string | null => {
    const normalizedPhone = normalizeParaguayPhone(value);

    return normalizedPhone ? normalizedPhone.replace('+', '') : null;
};
